import { action, createRequestTypes } from './base';

export const bomActionTypes = {
  GET_BOM: createRequestTypes('GET_BOM'),
  GET_BOM_BY_ID: createRequestTypes('GET_BOM_BY_ID'),
  CREATE_BOM: createRequestTypes('CREATE_BOM'),
  UPDATE_BOM: createRequestTypes('UPDATE_BOM'),
  UPDATE_STATUS_BOM: createRequestTypes('UPDATE_STATUS_BOM'),
  UPDATE_BOM_WORKFLOW_STEP: createRequestTypes('UPDATE_BOM_WORKFLOW_STEP'),
  DELETE_BOM: createRequestTypes('DELETE_BOM'),
  ACTIVATE_BOM: createRequestTypes('ACTIVATE_BOM'),
  BULK_UPLOAD_BOM: createRequestTypes('BULK_UPLOAD_BOM'),
  GET_BOM_JW: createRequestTypes('GET_BOM_JW'),
  UPDATE_BOM_JW: createRequestTypes('UPDATE_BOM_JW'),
  SHARE_BOM: createRequestTypes('SHARE_BOM'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param bomId
 * @param bomEntityId
 * @param bomEntityType
 * @param status
 * @param limit
 * @param page
 * @param tenantSellerId
 * @param selectedEntityType
 * @param callback
 */
class BOMActions {
  /**
   * @param {*} tenantId
   * @param {*} bomId
   * @param {*} status
   * @param {*} page
   * @param {*} limit
   * @param orgId
   * @param productSkuId
   * @param {*} searchKeyword
   * @param tenantDepartmentId
   * @return
   */
  getBOM = (orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, callback, searchBomByRm, approvalStatus, isMasterBom) => action(bomActionTypes.GET_BOM.REQUEST, {
    orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, callback, searchBomByRm, approvalStatus, isMasterBom,
  });

  /**
   *
   * @param {*} getBOMLoading
   * @return
   */
  getBOMLoading = (getBOMLoading) => action(bomActionTypes.GET_BOM.LOADING, {
    getBOMLoading,
  });

  /**
   * @return
   * @param boms
   * @param billOfMaterials
   * @param customFields
   */
  getBOMSuccess = (billOfMaterials) => action(bomActionTypes.GET_BOM.SUCCESS, {
    billOfMaterials,
  });

  /**
   * @param {*} tenantId
   * @param orgId
   * @param {*} bomId
   * @return
   */
  getBOMById = (orgId, tenantId, bomId, tenantDepartmentId, bomViewType, callback) => action(bomActionTypes.GET_BOM_BY_ID.REQUEST, {
    orgId, tenantId, bomId, tenantDepartmentId, bomViewType, callback,
  });

  /**
   *
   * @param {*} getBOMByIdLoading
   * @return
   */
  getBOMByIdLoading = (getBOMByIdLoading) => action(bomActionTypes.GET_BOM_BY_ID.LOADING, {
    getBOMByIdLoading,
  });

  /**
   * @return
   * @param selectedBOM
   * @param bomData
   */
  getBOMByIdSuccess = (selectedBOM) => action(bomActionTypes.GET_BOM_BY_ID.SUCCESS, {
    selectedBOM,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  createBOM = (payload, callback) => action(bomActionTypes.CREATE_BOM.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} createBOMLoading
   * @return
   */
  createBOMLoading = (createBOMLoading) => action(bomActionTypes.CREATE_BOM.LOADING, {
    createBOMLoading,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  updateBOM = (payload, callback) => action(bomActionTypes.UPDATE_BOM.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} updateBOMLoading
   * @return
   */
  updateBOMLoading = (updateBOMLoading) => action(bomActionTypes.UPDATE_BOM.LOADING, {
    updateBOMLoading,
  });

  /**
   * @param tenantId
   * @param bomId
   * @param orgId
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateBOMStatus = (payload, callback) => action(bomActionTypes.UPDATE_STATUS_BOM.REQUEST, {
    payload, callback,
  });

  /**
   * @param updateBOMStatusLoading
   * @param deleteBOMLoading
   * @return {{type: *}}
   */
  updateBOMStatusLoading = (updateBOMStatusLoading) => action(bomActionTypes.UPDATE_STATUS_BOM.LOADING, {
    updateBOMStatusLoading,
  });

  /**
   * @param tenantId
   * @param bomId
   * @param orgId
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteBOM = (payload, callback) => action(bomActionTypes.DELETE_BOM.REQUEST, {
    payload, callback,
  });

  /**
   * @param updateBOMStatusLoading
   * @param deleteBOMLoading
   * @return {{type: *}}
   */
  deleteBOMLoading = (deleteBOMLoading) => action(bomActionTypes.DELETE_BOM.LOADING, {
    deleteBOMLoading,
  });

  /**
   * @param tenantId
   * @param bomId
   * @param orgId
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateBOMWorkflowStep = (payload, callback) => action(bomActionTypes.UPDATE_BOM_WORKFLOW_STEP.REQUEST, {
    payload, callback,
  });

  /**
   * @param updateBOMStatusLoading
   * @param updateBOMWorkflowStepLoading
   * @param deleteBOMLoading
   * @return {{type: *}}
   */
  updateBOMWorkflowStepLoading = (updateBOMWorkflowStepLoading) => action(bomActionTypes.UPDATE_BOM_WORKFLOW_STEP.LOADING, {
    updateBOMWorkflowStepLoading,
  });

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  activateBOM = (payload, callback) => action(bomActionTypes.ACTIVATE_BOM.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param activateBOMLoading
   * @return
   */
  activateBOMLoading = (activateBOMLoading) => action(bomActionTypes.ACTIVATE_BOM.LOADING, {
    activateBOMLoading,
  });

  // BOM Bulk upload
  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  bulkUploadBOM = (payload, callback) => action(bomActionTypes.BULK_UPLOAD_BOM.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} uploadBOMLoading
   * @return
   */

  bulkUploadBOMLoading = (bulkUploadBOMLoading) => action(bomActionTypes.BULK_UPLOAD_BOM.LOADING, {
    bulkUploadBOMLoading,
  });

  bulkUploadBOMSuccess = (bulkUploadBOMResults) => action(bomActionTypes.BULK_UPLOAD_BOM.SUCCESS, {
    bulkUploadBOMResults,
  });

  getBomJobWork = (payload, callback) => action(bomActionTypes.GET_BOM_JW.REQUEST, {
    payload, callback,
  });

  getBomJobWorkLoading = (getBomJobWorkLoading) => action(bomActionTypes.GET_BOM_JW.LOADING, {
    getBomJobWorkLoading,
  });

  getBomJobWorkSuccess = (bomJobWorks) => action(bomActionTypes.GET_BOM_JW.SUCCESS, {
    bomJobWorks,
  });

  updateBomJobwork = (payload, callback) => action(bomActionTypes.UPDATE_BOM_JW.REQUEST, {
    payload, callback,
  });

  updateBomJobworkLoading = (updateBomJobworkLoading) => action(bomActionTypes.UPDATE_BOM_JW.LOADING, {
    updateBomJobworkLoading,
  });

  shareBOM = (payload, callback) => action(bomActionTypes.SHARE_BOM.REQUEST, {
    payload, callback,
  });

  shareBOMLoading = (shareBOMLoading) => action(bomActionTypes.SHARE_BOM.LOADING, {
    shareBOMLoading,
  });

}
export default new BOMActions();
